// removed by extract-text-webpack-plugin
module.exports = {"block-heading":"lwBC8pQvQNetIPgu8Grzf","newslist-block":"_3ziAt4r525MPmTs6IHsxL","frontpage":"_1HguSpzsPo4BBemxbuWE6q","horizontal":"_3GW3NliXx5hfJlzex7K0Ca","zebra":"_1ES-5awjvQq4jnXnwe1JYk","yellow":"Zb3vwYD730IOH-aTkERME","darkgray":"_34dNYbD53fVs1-HVj91ctQ","heading":"_1vqAf8yr9dbhKM5223gLNJ","description":"_3BGJ6T8Az_VB_JBVGGaSHV","articles":"nJbdIcd_EzjuLUYMS_t-u","button":"Dl-Xyqt8Evm0-d3YOl-IB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsListBlock/NewsListBlock.module.scss
// module id = 792
// module chunks = 0